import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  keyboard: {
    Escape: "close",
    Delete: "close",
    Tab: 'close',
  },

  Html: {
    video: {
      autoplay: true,
    },
  },
});
